export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/aadf7e204ac3ecb8628e2b693a3c4a40.svg";